import React, { useState } from 'react';

import { Row, Widget } from '@digital/ui';
import { Button, Modal } from 'antd';
import { dadosGeraisState, ordemCompraIdState, reloadState } from '../atoms';
import { useRecoilState, useRecoilValue } from 'recoil';
import { emitirContratoTotvs } from '@app/api/sas/relatorioHomologacao';
import { EStatusAprovacaoContrato, EStatusAprovacaoContratoTotvs } from '@app/enums';
import { Visibility } from '@app/components';
import { ETipoDemanda } from '@app/enums/ETipoDemanda';

const ModalEmitirContrato = () => {
    const [exibirModal, setExibirModal] = useState(false);
    const [integracaoSucesso, setIntegracaoSucesso] = useState(false);
    const ordemCompraId = useRecoilValue(ordemCompraIdState);
    const dadosGerais = useRecoilValue(dadosGeraisState);
    const [reload, setReload] = useRecoilState(reloadState);

    const onCancel = () => {
        setExibirModal(false);
        setIntegracaoSucesso(false);
    };

    const onSend = () => {
        setExibirModal(false);
        emitirContratoTotvs(ordemCompraId).then(data => {
            if (data && data.valid) {
                setIntegracaoSucesso(true);
                setExibirModal(true);
                setReload(!reload)
            }
        });
    };

    const onStart = () => {
        setExibirModal(true);
    };

    const buttons = () => {
        const actions = [];

        if (integracaoSucesso) {
            actions.push(
                <Button key="okBtn" type="primary" onClick={() => onCancel()}>
                    Ok
                </Button>,
            );
        } else {
            actions.push(
                <Button key="discordarBtn" type="danger" onClick={() => onCancel()}>
                    Não
                </Button>,
            );

            actions.push(
                <Button key="concordarBtn" type="success" onClick={() => onSend()}>
                    Sim
                </Button>,
            );
        }

        return actions;
    };

    return (
        <>

            <Visibility visible={dadosGerais.tipo === ETipoDemanda.NovaContratacao} >
                <Button onClick={() => onStart()} type="primary" className='button-sas-acoes' key="emitirContratoBtn" style={{ marginLeft: 10 }}
                    disabled={dadosGerais.contratoEmitido ||
                        dadosGerais.statusAprovacaoContratoTotvs !== EStatusAprovacaoContratoTotvs.APROVADO ||
                        dadosGerais.statusAprovacaoContrato !== EStatusAprovacaoContrato.ASSINATURA_CONCLUIDA}  >
                    Emitir Contrato
                </Button>
            </Visibility>

            <Visibility visible={dadosGerais.tipo === ETipoDemanda.Aditivo} >
                <Button onClick={() => onStart()} type="primary" className='button-sas-acoes' key="emitirContratoBtn" style={{ marginLeft: 10 }}
                    disabled={dadosGerais.contratoEmitido ||
                        dadosGerais.statusAprovacaoAditivoTotvs !== EStatusAprovacaoContratoTotvs.APROVADO ||
                        dadosGerais.statusAprovacaoAditivo !== EStatusAprovacaoContrato.ASSINATURA_CONCLUIDA}  >
                    Emitir Aditivo
                </Button>
            </Visibility>
            <Modal
                title="Emitir Contrato no Totvs"
                width="680px"
                visible={exibirModal}
                onCancel={() => onCancel()}
                footer={buttons()}>
                <Widget>
                    {integracaoSucesso === false ? (
                        <Row>
                            <p style={{ textAlign: 'center', paddingTop: '50px', paddingBottom: '50px' }}>
                                Tem certeza que deseja emitir o {dadosGerais.tipo === ETipoDemanda.Aditivo ? 'aditivo' : 'contrato'} no Totvs?
                            </p>
                        </Row>
                    ) : (
                        <Row>
                            <p style={{ textAlign: 'center', paddingTop: '50px', paddingBottom: '50px' }}>
                                Emissão do {dadosGerais.tipo === ETipoDemanda.Aditivo ? 'aditivo' : 'contrato'} enviada para o Totvs com sucesso. Aguarde a integração com o SGC para realizar o handover.
                            </p>
                        </Row>
                    )}
                </Widget>
            </Modal>
        </>
    )
}

export default ModalEmitirContrato